// Copied from apps/admin/src/features/map-view/model/constants/count-badge.ts (PRD #875).
/** The dark chip a map pin wears when it stands for several jobs; `place` positions it. */
export const countBadgeHtml = (text: string, place: string) =>
  `<span style="position:absolute;${place};z-index:1;min-width:16px;height:16px;padding:0 3px;` +
  `box-sizing:border-box;border-radius:8px;background:#1f2937;color:#fff;border:1.5px solid #fff;` +
  `font:700 10px/13px Inter,system-ui,sans-serif;text-align:center;white-space:nowrap;` +
  `pointer-events:none">${text}</span>`;
